<template>
  <div>
    <input
      v-model.trim="search"
      ref="search"
      type="text"
      :placeholder="$t('stockIn.searchProductList')"
      class="form-control"
    />
    <div class="ts-mt-3 ts-border ts-border-gray-300 ts-p-3 ts-rounded max-h">
      <ts-loading-banner :loading="loading">
        <table class="ts-w-full">
          <thead>
            <tr>
              <th class="ts-bg-gray-200 ts-px-2 ts-py-1">
                {{ $t('stockIn.group') }}
              </th>
              <th class="ts-bg-gray-200 ts-px-2 ts-py-1">
                {{ $t('stockIn.productName') }}
              </th>
              <th class="ts-bg-gray-200 ts-px-2 ts-py-1 ts-w-48">
                {{ $t('stockIn.qty') }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(pro, index) in this.getProduct({
								chosenProduct: model.product_detail,
								search: search,
							})"
              :key="index"
              class="ts-cursor-pointer hover:ts-bg-gray-300"
            >
              <td
                @click="addItem(pro)"
                class="ts-whitespace-no-wrap ts-px-2 ts-py-1"
              >
                {{ pro.group ? pro.group.pro_group_name_en : null }}
              </td>
              <td @click="addItem(pro)" class="ts-px-2 ts-py-1">
                {{ pro.product_name_en }}
              </td>
              <td>
                <input
                  type="number"
                  class="form-control"
                  v-model.number="pro.qty"
                  @keypress.enter="addItem(pro)"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </ts-loading-banner>
    </div>
    <small
      ><i>{{ $t('stockIn.clickToAddProduct') }}</i></small
    >
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { debounce } from 'lodash'
export default {
  name: 'modalSearchToAddProduct',
  props: ['value'],
  data() {
    return {
      model: {},
      loading: false,
      search: '',
    }
  },
  computed: {
    ...mapGetters('stock/stockIn', [
      'getProduct',
      'isDefaultUom',
      'getCostPrice',
    ])
  },
  created() {
    this.model = this.value
    this.$nextTick(() => {
      this.$refs.search.focus()
    })
  },
  methods: {
    addItem(product) {
      var uom_id = this.isDefaultUom(product.product_id)
      let newRow = {
        product_id: product.product_id,
        uom_id: uom_id,
        qty: product.qty ? product.qty : 1,
        cost: this.getCostPrice({
          product_id: product.product_id,
          uom_id: uom_id,
        }),
        discount_rate: 0,
        discount_type: '%',
        total_after_discount: null,
        vat_rate: 0,
        vat_amount: 0,
        grand_total: 0,
        expiry_date: null,
        is_expire: false,
        product_grade: '',
      }

      this.model.product_detail.push(_.clone(newRow))
      this.$nextTick(() => {
				this.$refs.search.focus();
				this.$refs.search.select();
      })
    },
  }
}
</script>

<style scoped>
.max-h {
  min-height: 50vh;
  max-height: 60vh;
  overflow: scroll;
}
</style>